import React from 'react';

function Skeleton({
    rows
}) {
    return (
        <div className="w-100 h-100">
            <div className="d-flex flex-column h-100">
                {
                    rows.map((row, index) => {
                        if (row.full) {
                            return (
                                <div key={index} className="sk flex-grow-1 mt-2"></div>
                            )
                        } else {
                            return (
                                <div key={index} className="row mt-2">
                                    {
                                        row.columns.map((column, index) => (
                                            <div className={
                                                `${'col-' + column.size}`
                                            }>
                                                <div className='sk'></div>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }
                    })
                }
                {/* <div className="row">
                    <div className="col-10">
                        <div className="sk"></div>
                    </div>
                    <div className="col-2">
                        <div className="sk"></div>
                    </div>
                </div>
                <div className="sk flex-grow-1" style={{ marginTop: 10 }} ></div> */}
            </div>
        </div>
    )
};

export default Skeleton;